import client from '../../client'

import { RECEIVE_CONFIGS, RECEIVE_CONFIGS_ERROR } from './consts'

function receiveConfigs(config) {
  return { type: RECEIVE_CONFIGS, config }
}

function receiveConfigsError(error) {
  return { type: RECEIVE_CONFIGS_ERROR, error }
}

export default function loadConfigs() {
  return (dispatch) => {
    client.get('/configs')
      .then((response) => response.data)
      .then((json) => dispatch(receiveConfigs(json)))
      // A network error (no response, e.g. the request never reached the server)
      // has no error.response, so fall back to the Error's own message.
      .catch((error) => dispatch(receiveConfigsError(error.response?.data?.error ?? error.message)))
  }
}
